import { render, staticRenderFns } from "./incomeData.vue?vue&type=template&id=49bf98de&scoped=true"
import script from "./incomeData.vue?vue&type=script&lang=js"
export * from "./incomeData.vue?vue&type=script&lang=js"
import style0 from "./incomeData.vue?vue&type=style&index=0&id=49bf98de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bf98de",
  null
  
)

export default component.exports